export enum Size {
  NANO = 0.8,
  MICRO = 1.6,
  TINY = 2.4,
  SMALL = 3.2,
  MEDIUM = 4.8,
  BIG = 6.4,
  LARGE = 12.8,
}
